import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientSaveLegalHeadFirstHeadsStepMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';

import { parseLegalClientLegalHeadEntity } from './helpers';

export const useLegalClientSaveLegalHeadFirstHeadsStep = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientSaveLegalHeadFirstHeadsStepMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientSaveLegalHeadFirstHeadsStep
      ? parseLegalClientLegalHeadEntity(
          data.legalClientSaveLegalHeadFirstHeadsStep
        )
      : undefined,
    loading,
    error,
    saveHeadsStep: useCallback(
      async (id: string, legalHeadId: string) => {
        const res = await handle({
          variables: {
            id,
            legalHeadId,
          },
        });
        return res.data?.legalClientSaveLegalHeadFirstHeadsStep
          ? parseLegalClientLegalHeadEntity(
              res.data.legalClientSaveLegalHeadFirstHeadsStep
            )
          : undefined;
      },
      [handle]
    ),
  };
};
